import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { permissionTitleStyles } from './styles/Permissions.css';
import Sidebar from './Sidebar';
import PermissionsTable from './Table/Permissions/PermissionsTable';
import AppsTable from './Table/Apps/AppsTable';
import { ToggleButtonGroup, ButtonDetails } from '../../../common/ToggleButtonGroup';

class Permissions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sections: [],
            currentSection: {},
            sectionNames: [],
            apps: []
        }
    }

    setExpandPermissions = (isExpanded) => {
        this.setState({ showSubRows: isExpanded });
    };

    setActiveSection = (sectionName) => {
        let sections = this.state.sections;
        let section = sections.filter((section) => {
            return section.name === sectionName
        })[0];
        if (section !== null && section.permissions !== null) {
            this.setState({ currentSection: section });
        }
    };

    getSections = () => {
        if (Array.isArray(this.props.permissions)) {
            let permissions = this.props.permissions;
            permissions.sort((a, b) => {
                return a['section'].localeCompare(b['section']);
            });

            let sections = [];
            let sectionNames = [];
            sections.push({ name: 'Products' });
            sectionNames.push('Products');
            let currentSection = { name: '' };
            permissions.forEach((permission) => {
                if (permission.section !== currentSection.name) {
                    if (currentSection.name)
                        sections.push({ ...currentSection });
                    sectionNames.push(permission.section);
                    currentSection = { name: permission.section, permissions: [] };
                    currentSection.permissions.push(permission);
                } else currentSection.permissions.push(permission);
            });
            sections.push({ ...currentSection });
            this.setState({ sections, currentSection: sections[1], sectionNames });
        }
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.showSubRows !== this.state.showSubRows) {
            return true;
        }

        return !(nextProps.permissions === this.props.permissions
            && this.state.currentSection === nextState.currentSection);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.apps !== this.state.apps) {
            this.setState({ apps: nextProps.apps });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.permissions !== this.props.permissions) {
            this.getSections();
        }
    }

    componentDidMount() {
        this.getSections();
    }

    render() {
        const permissions = this.state.currentSection && this.state.currentSection.permissions
            ? this.state.currentSection.permissions
            : [];
        return (
            <div className="card mt-4">
                <div className="card-block p-3">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="card-title" style={permissionTitleStyles}>Permissions</h3>
                            <ToggleButtonGroup buttonDetailsList={[
                                new ButtonDetails('view_day', () => this.setExpandPermissions(true)),
                                new ButtonDetails('dehaze', () => this.setExpandPermissions(false))]}
                                               additionalClasses={['float-right']} isSmall={true} />
                        </div>
                    </div>
                    <div className="row">
                        <Sidebar items={this.state.sectionNames} setActiveSection={this.setActiveSection} />
                        {this.state.currentSection.name === 'Products' ?
                            <AppsTable disabled={this.props.disabled} addApp={this.props.addApp}
                                       removeApp={this.props.removeApp} />
                            :
                            <PermissionsTable
                                permissions={permissions}
                                disabled={this.props.disabled}
                                showSubRows={this.state.showSubRows} />}
                    </div>
                </div>
            </div>
        );
    }

}


Permissions.propTypes = {
    //List of permissions from the API
    permissions: PropTypes.array,
    apps: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    addApp: PropTypes.func.isRequired,
    removeApp: PropTypes.func.isRequired
};

export default Permissions;
